import { createNativeStackNavigator } from "@react-navigation/native-stack";
import React from "react";
import { ViewStyle, Platform } from "react-native";
import { WebModal } from "./WebModal";

export function withWebModalStack<T extends React.ComponentType<any>>(
  Component: T,
  dismissable?: boolean,
  options?: {
    width?: number;

    height?: number;
    contentStyle?: ViewStyle;
  }
) {
  if (Platform.OS === "web") {
    const Stack = createNativeStackNavigator();

    return function InnerWebModalStack(props: any) {
      return (
        <WebModal
          width={options?.width}
          height={options?.height}
          dismissable={dismissable}
          contentStyle={options?.contentStyle}
        >
          <Stack.Navigator>
            <Stack.Screen
              name="Modal"
              options={{
                title: "",
              }}
              initialParams={props.route.params}
            >
              {({ navigation }) => (
                <Component
                  {...props}
                  navigation={{
                    ...props.navigation,
                    setOptions: navigation.setOptions,
                  }}
                />
              )}
            </Stack.Screen>
          </Stack.Navigator>
        </WebModal>
      );
    };
  }
  return Component as T;
}
